<template>
  <oa-modal :name="name">
    <template slot="header">
      <!-- <img class="modal-icon" src="@/assets/styles/frontend-library/images/close.svg" width="34"/> -->
      <span>Close lead</span>
    </template>
    <template slot="description">
      This will remove the lead from your active list and you will no longer be able to provide updates.
      Please let us know why you are closing this lead.
    </template>

    <template slot="body">
      <div class="form-group" v-if="!lamStagePostViewed()">
        <label for="reason-for-closing-lead">Reason for closing the lead</label>
        <select
          @change="onSelectReason($event)"
          id="reason-for-closing-lead"
          v-model="closeLeadReasonId">
          <option value="">Select reason...</option>
          <option v-for="reason in closeLeadReasons" :key="reason.id" :value="reason.id">
            {{ reason.value }}
          </option>
        </select>
      </div>

      <div v-if="showReturnDate" class="form-group">
        <label for="return-date" >Return Date</label>
        <oa-datepicker v-model="returnDate" />
      </div>

      <div v-if="showNoOaLead" class="form-group">
        <label for="reason-for-no-oa-leads">
          Why don't you want to accept OpenAgent Leads anymore?
        </label>
        <select id="reason-for-no-oa-leads" v-model="noOALeadReasonId">
          <option value="">Select reason...</option>
          <option v-for="reason in noOaLeadReasons" :key="reason.id" :value="reason.id">
            {{ reason.value }}
          </option>
        </select>
      </div>

      <div v-if="showIncludeSuburb" class="form-group">
        <label for="include-suburb-answer" >
          Do you still want to accept leads from {{lead.suburb}} in the future?
        </label>
        <select id="include-suburb-answer" v-model="includeSuburb">
          <option value="">Please select...</option>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </select>
      </div>

      <div v-if="showComment" class="form-group">
        <label for="comments">Comments</label>
        <textarea id="comments" rows="5" v-model="comment"></textarea>
      </div>
    </template>

    <template slot="error">
      <span v-if="errorMsg !== ''" id="error-message" class="error inline">
        {{ errorMsg }}
      </span>
    </template>

    <template slot="footer">
      <div>
        <button class="btn btn-green" :disabled="disableSubmit" @click="declineLead()">
          Confirm
        </button>
        <button class="btn btn-small white-bg ut-ml-4"  @click="closeModal()">
          Cancel
        </button>
      </div>
    </template>

  </oa-modal>

</template>

<script>
import OaModal from '@/components/Modals/OaModal.vue';
import { LeadAgentLeadStateType } from '@/Mapper/LeadAgentLeadStateType';
import { LeadAgentLeadStageType } from '@/Mapper/LeadAgentLeadStageType';
import OaDatepicker from '@/components/Forms/OaDatepicker';
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'CloseLeadModal',
  components: { OaModal, OaDatepicker },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
      user: state => state.userStore.user,
      lam: state => state.leadAgentMappingStore.lam,
      lead: state => state.leadAgentMappingStore.lead,
      agentExperiments: state => state.experimentStore.agentExperiments,
    }),
    ...mapGetters('leadAgentMappingStore', [
      'lamIsOnHoldIgnoredLead',
    ]),
  },
  data() {
    return {
      name: 'close-lead-modal',
      closeLeadReasons: [
        { id: 1, value: 'I have an existing relationship with vendor' },
        { id: 2, value: 'I was already sent this lead by another referral agency' },
        { id: 7, value: 'I am too busy' },
        { id: 3, value: 'I do not service this area' },
        { id: 4, value: 'I am currently on or soon going on leave' },
        { id: 5, value: 'Other (please specify in comments)' },
        { id: 6, value: 'I no longer want to accept OpenAgent leads' },
      ],
      noOaLeadReasons: [
        { id: 1, value: 'I don\'t need the extra business' },
        { id: 2, value: 'I am no longer selling properties / no longer in the industry' },
        { id: 3, value: 'I don\'t want to pay the referral fee' },
        { id: 6, value: 'I am too busy' },
        { id: 4, value: 'I am currently on or soon going on leave' },
        { id: 5, value: 'Other (please specify in comments)' },
      ],
      returnDate: '',
      closeLeadReasonId: '',
      noOALeadReasonId: '',
      includeSuburb: '',
      showComment: false,
      showReturnDate: false,
      showNoOaLead: false,
      showIncludeSuburb: false,
      requiredComment: false,
      disableSubmit: true,
      comment: '',
      errorMsg: '',
    };
  },
  methods: {
    ...mapActions('leadAgentMappingStore', [
      'updateLeadAgentMapping',
    ]),
    ...mapActions('agentStore', [
      'updateAgent',
    ]),
    closeModal() {
      this.resetFormView();
      this.$modal.hide(this.name);
    },
    resetFormView() {
      this.showComment = false;
      this.showReturnDate = false;
      this.showNoOaLead = false;
      this.showIncludeSuburb = false;
      this.requiredComment = false;
      this.disableSubmit = true;
      this.returnDate = '';
      this.noOALeadReasonId = '';
      this.includeSuburb = '';
      this.errorMsg = '';
      this.comment = '';
    },
    validateDecline() {
      let isValid = true;
      this.errorMsg = '';
      if (this.requiredComment && this.comment.length === 0) {
        this.setError('Please specify a reason in comments.');
        isValid = false;
      }
      if (this.showNoOaLead && this.noOALeadReasonId === '') {
        this.setError('Please specify why you do not want to receive OA leads anymore.');
        isValid = false;
      }
      if (this.showNoOaLead && this.noOALeadReasonId === 5 && this.comment.length === 0) {
        this.setError('Please specify a reason in comments.');
        isValid = false;
      }
      if (this.showReturnDate && !this.returnDate) {
        this.setError('Please specify a date.');
        isValid = false;
      }
      if (this.showIncludeSuburb && this.includeSuburb === '') {
        this.setError('Please specify if you want to include future leads in the suburb.');
        isValid = false;
      }
      return isValid;
    },
    setError(msg) {
      if (this.errorMsg.length === 0) {
        this.errorMsg = msg;
      }
    },
    declineLead() {
      if (!this.validateDecline()) {
        return false;
      }
      /**
       * If the agent is on hold
       * because of ignoring lead
       * then put him off hold
       */
      this.onHoldIgnoredLeadUpdate();

      const payload = {
        lamid: this.lam.id,
        data: {
          statetypeid: LeadAgentLeadStateType.Closed,
          leaddeclinedreasoncomment: this.comment,
          leaddeclinedreason: this.getCloseLeadReason(),
          leaddeclinednomoreleads: this.getNoOALeadReason(),
          leavereturndate: (this.returnDate !== '' ? this.$helpers.formatDateApi(this.returnDate) : ''),
          oauserid: !!this.user ? this.user.id : '',
          oauserkey: !!this.user ? this.user.key : '',
        },
      };
      this.updateLeadAgentMapping(payload)
        .then(() => {
          if (this.includeSuburb === 'yes') {
            this.includeLeadsInSuburb();
          }
          this.closeModal();
          window.scrollTo({ top: 0, behavior: 'smooth' }); // Scrolls to the top of the page
        }).catch((err) => {
          // Probably want to do something :)
          this.disableSubmit = false;
          console.log(err);
        });
    },
    onHoldIgnoredLeadUpdate() {
      if (this.lamIsOnHoldIgnoredLead) {
        const payload = {
          data: {
            agentid: this.lam.agentid,
            // agentid: this.agent.id,
            leadid: this.lead.id,
            onhold: 0,
            eventsource: 'API',
          },
        };

        this.updateAgent(payload)
          .then(() => {})
          .catch((err) => {
            // Probably want to do something :)
            console.log(err);
          });
      }
    },
    includeLeadsInSuburb() {
      const agentQAData = {
        includesuburbs: this.lead.postcodeid,
      };

      this.$apiServices.agent.updateAgentQA(agentQAData, this.agent.key)
        .then(() => {})
        .catch((err) => {
          // Probably want to do something :)
          console.log(err);
        });
    },
    getCloseLeadReason() {
      if (this.closeLeadReasonId === 5) {
        return 'Other';
      }

      if (this.lamStagePostViewed()) {
        // for post referred stage, save decline reason as "Closed lead by agent"
        return 'Closed lead by agent';
      }

      if (this.closeLeadReasons.some(e => e.id === this.closeLeadReasonId)) {
        for (let i = 0; i < this.closeLeadReasons.length; i++) {
          if (this.closeLeadReasons[i].id === this.closeLeadReasonId) {
            return this.closeLeadReasons[i].value;
          }
        }
      } else {
        return 'No reason provided';
      }
    },
    getNoOALeadReason() {
      if (this.noOALeadReasonId === 5) {
        return 'Other';
      }
      if (this.noOaLeadReasons.some(e => e.id === this.noOALeadReasonId)) {
        for (let i = 0; i < this.noOaLeadReasons.length; i++) {
          if (this.noOaLeadReasons[i].id === this.noOALeadReasonId) {
            return this.noOaLeadReasons[i].value;
          }
        }
      }
      return '';
    },
    onSelectReason(event) {
      this.resetFormView();
      const selectedReasonId = event.target.value;

      if (selectedReasonId) {
        this.showComment = true;
        this.disableSubmit = false;
      }

      if (['7', '4'].includes(selectedReasonId)) {
        this.showReturnDate = true;
      }

      if (selectedReasonId === '6') {
        this.showNoOaLead = true;
      }

      if (selectedReasonId === '5') {
        this.requiredComment = true;
      }

      if (selectedReasonId === '3') {
        this.showIncludeSuburb = true;
      }
    },
    lamStagePostViewed() {
      // for post referred stage, show comments box and hide reason dropdown
      if (this.lam.stagetypeid > LeadAgentLeadStageType.Viewed
      && [
        LeadAgentLeadStageType.Shown_To_Vendor,
        LeadAgentLeadStageType.Shortilisted,
      ].indexOf(this.lam.stagetypeid) === -1) {
        this.showComment = true;
        this.requiredComment = true;
        this.disableSubmit = false;
        return true;
      }
      return false;
    },
  },
};


</script>

<style scoped lang="scss">


</style>
